import "./HelpCenterDE.module.css";
import Header from "@/reusable_sections/Header";
import HelpTopics from "./sections/HelpTopics";
import Footer from "@/reusable_sections/Footer";
export default function HelpCenterDEPage() {
  return <div>
      <Header />
      <HelpTopics />
      <Footer />
    </div>;
}